function getAuthHeader(token){
  return ['Authorization', `Token token=${token}`]
}

export {getAuthHeader}



// WEBPACK FOOTER //
// ./src/utils/AuthHeaderBuilder.js